// extracted by mini-css-extract-plugin
module.exports = {"productListCard":"_3qy_ib","image":"_2pb-UC","content":"_312r18","mainContent":"_3H_MXm","mainContentLeftNode":"_3M3vx_","label":"l1yNp7","shine-lines":"_3_z4Ch"};